/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 13:19:29
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/CustomerEligible/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Condition from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const _base = 'customerCondition';
export const _type = [_base, 'conditionType'];
const _customer = [_base, 'customers'];
const _tags = [_base, 'customerTags'];

const CustomerEligibleCondition = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { form, disableEdit, disabledEveryoneDependency } = props;
  return (
    <SectionWrapper
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n(
        'salesChannelDirectDiscount.eligibalCondition.customerEligibleCondition',
      )}>
      <Condition
        form={form}
        radioName={_type}
        tagsName={_tags}
        customerName={_customer}
        disableEdit={disableEdit}
        disabledEveryoneDependency={disabledEveryoneDependency}
      />
    </SectionWrapper>
  );
};
export default CustomerEligibleCondition;
